import React from 'react';
import { Container } from 'semantic-ui-react';
import ProgrammingList from "../../../components/programming-list-page/ProgrammingList";

const ProgrammingListPage: React.FC = () => {
    return (
        <Container fluid style={{ marginTop: '20px', padding: '20px'}}>
            <ProgrammingList /> {/* Usando o componente */}
        </Container>
    );
};

export default ProgrammingListPage;